import { createContext } from 'react';

import type { StoreApi } from 'zustand';

import type { ConfigStore } from '../stores';

export const ConfigContext = createContext<StoreApi<ConfigStore> | null>(null);
